import { useMutation } from "@tanstack/react-query";
import { updateData } from "@/lib/services/data-layer";
import { url } from "@/lib/services/data-layer/core";

const updateVirtualPosDetails = async ({
  id,
  ...props
}: {
  id: string;
  fullName: string;
  description: string;
}): Promise<void> => {
  return await updateData(url + `vpos/` + id, props);
};

export const useUpdateVirtualPosDetailsMutation = () => {
  return useMutation({
    mutationFn: updateVirtualPosDetails,
  });
};
